"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccessRequestPage = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _weirDls = require("@weirgroup/weir-dls");
var _accessRequestconstants = require("./accessRequestconstants");
var _table = require("./table.constants");
var _reactRedux = require("react-redux");
var _UserCard = require("./UserCard");
var _manageYourTeam = require("../manageYourTeam.action");
var _accessRequestModule = _interopRequireDefault(require("./accessRequest.module.css"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const AccessRequestPage = props => {
  const dispatch = (0, _reactRedux.useDispatch)();
  const {
    pendingAccessRequests = [],
    accessRequestRoles = {},
    applicationBusinessEntities = {},
    mineSiteLabel
  } = (0, _reactRedux.useSelector)(x => {
    return x.manageYourTeam;
  });
  const [displayRecords, setDisplayRecords] = (0, _react.useState)([]);
  const [pageIndex, setPageIndex] = (0, _react.useState)(1);
  const totalRecords = pendingAccessRequests ? pendingAccessRequests.length : 0;
  const pageSize = 25;
  const maxPages = Math.ceil(totalRecords / pageSize);
  (0, _react.useEffect)(() => {
    (0, _manageYourTeam.getPendingAccessRequests)(dispatch, props.appId);
  }, []);
  const getDisplayRecords = () => {
    let pageRecords = [];
    if (pendingAccessRequests && pendingAccessRequests.length > 0) {
      pageRecords = pendingAccessRequests.slice((pageIndex - 1) * pageSize, pageIndex * pageSize);
    }
    setDisplayRecords(pageRecords);
  };
  (0, _react.useEffect)(() => {
    getDisplayRecords();
  }, [pendingAccessRequests, pageIndex]);
  const isPendingAccessRequestsEmpty = pendingAccessRequests.length === 0;
  (0, _react.useEffect)(() => {
    if (!isPendingAccessRequestsEmpty) {
      Array.from(new Set(pendingAccessRequests.map(x => x.appObjectId))).forEach(x => {
        if (!accessRequestRoles[x]) {
          (0, _manageYourTeam.getAccessRequestRoles)(dispatch, props.appId)(x);
        }
        if (!applicationBusinessEntities[x]) {
          (0, _manageYourTeam.getApplicationConfiguredBusinessEntities)(dispatch, props.appId)(x);
        }
      });
    }
  }, [pendingAccessRequests.length]);
  const [selectedAccepted, setSelectedAccepted] = (0, _react.useState)([]);
  const [selectedRejected, setSelectedRejected] = (0, _react.useState)([]);
  const [selectedRoles, setSelectedRoles] = (0, _react.useState)([]);
  const [selectedBusinessEntities, setSelectedBusinessEntities] = (0, _react.useState)([]);
  const [isAcceptRejectDisabled, setIsAcceptRejectDisabled] = (0, _react.useState)({});
  const handleAccept = data => {
    setSelectedRejected(state => state.filter(accepted => accepted.id.source !== data.id.source));
    setSelectedAccepted(state => {
      // Toggle = Remove if exists / Add if not exists
      const filterData = state.filter(accepted => accepted.id.source === data.id.source);
      if (filterData.length > 0) {
        // reset the role and minesite values if selected
        setSelectedRoles(state => state.filter(x => x.id !== data.id.source));
        setSelectedBusinessEntities(state => state.filter(x => x.id !== data.id.source));
        return state.filter(accepted => accepted.id.source !== data.id.source);
      }
      return [...state, data];
    });
  };
  const handleReject = data => {
    setSelectedAccepted(state => state.filter(accepted => accepted.id.source !== data.id.source));
    setSelectedRejected(state => {
      // Toggle = Remove if exists / Add if not exists
      const filterValue = state.filter(rejected => rejected.id.source === data.id.source);
      if (filterValue.length > 0) {
        return state.filter(rejected => rejected.id.source !== data.id.source);
      } else {
        // reset the role and minesite values if already selected
        setSelectedRoles(state => state.filter(x => x.id !== data.id.source));
        setSelectedBusinessEntities(state => state.filter(x => x.id !== data.id.source));
        return [...state, data];
      }
    });
  };
  const isDisabled = id => {
    const selectedRole = selectedRoles.filter(x => x.id === id);
    const selectedBusinessEntity = selectedBusinessEntities.filter(x => x.id === id);
    setIsAcceptRejectDisabled(state => ({
      ...state,
      [id]: selectedRole.length === 0 || selectedBusinessEntity.length === 0
    }));
  };
  const isRejectSelected = data => {
    return selectedRejected.filter(x => x.id.source === data.id.source).length > 0;
  };
  const clearSelection = () => {
    setSelectedAccepted([]);
    setSelectedRejected([]);
    setSelectedRoles([]);
    setSelectedBusinessEntities([]);
    setIsAcceptRejectDisabled({});
  };
  const handleSubmit = () => {
    if (selectedAccepted.length === 0 && selectedRejected.length === 0) {
      dispatch(_manageYourTeam.notificationActions.showNotification({
        notificationType: _accessRequestconstants.CONSTANTS.ALERT,
        notificationTitle: _accessRequestconstants.CONSTANTS.UNABLE_SUBMIT,
        notificationMessage: _accessRequestconstants.CONSTANTS.SUBMIT_REQUESTS_ERROR
      }));
      return;
    }
    const accepted = selectedAccepted.map(x => {
      var _selectedRoles$find, _selectedBusinessEnti;
      return {
        email: x.userEmail.source,
        applicationObjectId: x.appObjectId.source,
        applicationRoleObjectId: (_selectedRoles$find = selectedRoles.find(r => r.id === x.id.source)) === null || _selectedRoles$find === void 0 ? void 0 : _selectedRoles$find.appRoleObjectId,
        businessEntityObjectId: (_selectedBusinessEnti = selectedBusinessEntities.find(r => r.id === x.id.source)) === null || _selectedBusinessEnti === void 0 ? void 0 : _selectedBusinessEnti.businessEntityObjectId,
        Status: 'Approved'
      };
    });
    const rejected = selectedRejected.map(x => ({
      email: x.userEmail.source,
      applicationObjectId: x.appObjectId.source,
      Status: 'Rejected'
    }));
    (0, _manageYourTeam.approveRejectAccessRequests)(dispatch, clearSelection, props.appId)([...accepted, ...rejected]);
  };
  const commonDropdownProps = data => ({
    disabled: isRejectSelected(data),
    minSearchStart: 1
  });
  const tableHeaders = [{
    label: _accessRequestconstants.CONSTANTS.DATE_TIME,
    type: 'date',
    sortable: true,
    key: 'addedOn'
  }, {
    label: _accessRequestconstants.CONSTANTS.USER,
    sortable: true,
    filterable: true,
    key: 'userFirstName',
    renderFn(data) {
      return /*#__PURE__*/_react.default.createElement(_UserCard.UserCard, {
        userData: data
      });
    }
  }, {
    label: _accessRequestconstants.CONSTANTS.COUNTRY,
    sortable: true,
    type: 'string',
    key: 'country'
  }, {
    label: _accessRequestconstants.CONSTANTS.ROLE,
    type: 'string',
    key: 'appRoleDisplayName',
    renderFn(data) {
      if (accessRequestRoles[data.appObjectId.source]) {
        var _selectedRoles$find2;
        return /*#__PURE__*/_react.default.createElement(_weirDls.Dropdown, (0, _extends2.default)({
          key: "".concat(data.id.source, "appRoleObjectId"),
          placeholderText: _accessRequestconstants.CONSTANTS.SELECT_ROLE
        }, commonDropdownProps(data), {
          value: (_selectedRoles$find2 = selectedRoles.find(x => x.id === data.id.source)) === null || _selectedRoles$find2 === void 0 ? void 0 : _selectedRoles$find2.appRoleObjectId,
          setValue: appRoleObjectId => {
            isDisabled(data.id.source);
            if (appRoleObjectId) {
              setSelectedRoles(roles => {
                const i = roles.findIndex(_item => _item.id === data.id.source);
                if (i > -1) {
                  let updatedRoles = Object.assign([], roles);
                  updatedRoles[i]['appRoleObjectId'] = appRoleObjectId;
                  return updatedRoles;
                } else {
                  return [...roles, {
                    id: data.id.source,
                    appRoleObjectId
                  }];
                }
              });
            }
          },
          selectData: accessRequestRoles[data.appObjectId.source].map(x => ({
            value: x.appRoleObjectId,
            name: x.appRoleDisplayName
          })),
          optionsOverlay: false,
          selectSize: 5
        }));
      }
    }
  }, {
    label: mineSiteLabel.singular,
    type: 'string',
    key: 'groupName',
    renderFn(data) {
      if (applicationBusinessEntities[data.appObjectId.source]) {
        var _selectedBusinessEnti2;
        return /*#__PURE__*/_react.default.createElement(_weirDls.Dropdown, (0, _extends2.default)({
          key: "".concat(data.id.source, "businessEntityObjectId"),
          placeholderText: _accessRequestconstants.CONSTANTS.SELECT_MINE_SITE.replace('<MineSiteLabel>', mineSiteLabel.singular)
        }, commonDropdownProps(data), {
          value: (_selectedBusinessEnti2 = selectedBusinessEntities.find(x => x.id === data.id.source)) === null || _selectedBusinessEnti2 === void 0 ? void 0 : _selectedBusinessEnti2.businessEntityObjectId,
          setValue: businessEntityObjectId => {
            isDisabled(data.id.source);
            if (businessEntityObjectId) {
              setSelectedBusinessEntities(businessEntities => {
                const i = businessEntities.findIndex(_item => _item.id === data.id.source);
                if (i > -1) {
                  let updatedBusinessEntities = Object.assign([], businessEntities);
                  updatedBusinessEntities[i]['businessEntityObjectId'] = businessEntityObjectId;
                  return updatedBusinessEntities;
                } else {
                  return [...businessEntities, {
                    id: data.id.source,
                    businessEntityObjectId
                  }];
                }
              });
            }
          },
          selectData: (applicationBusinessEntities[data.appObjectId.source] || []).map(x => ({
            value: x.businessEntityObjectId,
            name: x.businessEntityDisplayName
          })),
          optionsOverlay: false,
          selectSize: 5
        }));
      }
    }
  }, {
    label: _accessRequestconstants.CONSTANTS.APPROVE,
    type: 'string',
    key: 'approve',
    renderFn(data) {
      return /*#__PURE__*/_react.default.createElement(_weirDls.Radiobox, {
        disabled: isAcceptRejectDisabled[data.id.source] === false ? false : true,
        checked: selectedAccepted.filter(x => x.id.source === data.id.source).length > 0,
        onChange: () => handleAccept(data)
      });
    }
  }, {
    label: _accessRequestconstants.CONSTANTS.REJECT,
    type: 'string',
    key: 'reject',
    renderFn(data) {
      return /*#__PURE__*/_react.default.createElement(_weirDls.Radiobox, {
        checked: selectedRejected.filter(x => x.id.source === data.id.source).length > 0,
        onChange: () => handleReject(data)
      });
    }
  }];
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(_accessRequestModule.default.textStyle, " ").concat(_accessRequestModule.default.mb16, " ").concat(_accessRequestModule.default.mt10)
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "".concat(_accessRequestModule.default.fontWeightBold)
  }, _accessRequestconstants.CONSTANTS.toApproveRequestTitle), " ", /*#__PURE__*/_react.default.createElement("span", null, _accessRequestconstants.CONSTANTS.toApproveRequestTitleDes.replace('<MineSiteLabel>', mineSiteLabel.singular))), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(_accessRequestModule.default.textStyle, " ").concat(_accessRequestModule.default.mb16)
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "".concat(_accessRequestModule.default.fontWeightBold)
  }, _accessRequestconstants.CONSTANTS.toRejectRequestTitle), " ", /*#__PURE__*/_react.default.createElement("span", null, _accessRequestconstants.CONSTANTS.toRejectRequestTitleDes.replace('<MineSiteLabel>', mineSiteLabel.singular))), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(_accessRequestModule.default.textStyle, " ").concat(_accessRequestModule.default.mt0, " ").concat(_accessRequestModule.default.mb0)
  }, _accessRequestconstants.CONSTANTS.youCanApproveOrRejectTitle), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(_accessRequestModule.default.textStyle, " ").concat(_accessRequestModule.default.mb16, " ").concat(_accessRequestModule.default.mt16)
  }, _accessRequestconstants.CONSTANTS.onceYouSelectedTitle), /*#__PURE__*/_react.default.createElement("div", {
    "data-test": "pending-access-requests-table",
    className: _accessRequestModule.default.tableWrapper
  }, /*#__PURE__*/_react.default.createElement(_weirDls.Table, {
    header: tableHeaders,
    source: displayRecords,
    searchable: true,
    sortable: true,
    searchPlaceholder: _table.tableConstants.SEARCH_PLACEHOLDER_ONBLUR,
    noResultsText: _accessRequestconstants.CONSTANTS.NO_RESULTS_TEXT,
    title: _accessRequestconstants.CONSTANTS.ACCESS_REQUESTS_TABLE_HEADER,
    searchPlaceHolderOnBlur: _table.tableConstants.SEARCH_PLACEHOLDER_ONBLUR,
    searchPlaceHolderOnFocus: _table.tableConstants.SEARCH_PLACEHOLDER_ONFOCUS,
    primaryActionBtnTitle: _accessRequestconstants.CONSTANTS.SUBMIT,
    onPrimaryActionBtnClick: handleSubmit,
    searchResultSingle: _table.tableConstants.RESULTS_LBL_SINGULAR,
    searchResultPlural: _table.tableConstants.RESULTS_LBL_PLURAL
  }), pendingAccessRequests && pendingAccessRequests.length > pageSize && /*#__PURE__*/_react.default.createElement("div", {
    className: _accessRequestModule.default.paddingTop32 + ' ' + _accessRequestModule.default.alignCenter
  }, /*#__PURE__*/_react.default.createElement(_weirDls.Pagination, {
    currentPage: pageIndex,
    totalRows: totalRecords,
    pageRows: pageSize,
    onPrevious: () => setPageIndex(pageIndex > 1 ? pageIndex - 1 : 1),
    onNext: () => setPageIndex(pageIndex < maxPages ? pageIndex + 1 : maxPages),
    onSelect: index => {
      setPageIndex(index);
    },
    onLoadMore: () => {}
  }))));
};
exports.AccessRequestPage = AccessRequestPage;